(function () {
  'use strict';

  var body = document.querySelector('.main-article__body');
  if (!body) return;

  var headings = body.querySelectorAll('h2, h3');
  if (headings.length < 2) return; // skip TOC for short articles

  // ── Assign IDs to headings ──────────────────────────
  var usedSlugs = {};

  function slugify(text) {
    var base = (text || '').toLowerCase().trim()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';

    var slug = base;
    var n = 1;
    while (usedSlugs[slug]) { slug = base + '-' + (++n); }
    usedSlugs[slug] = true;
    return slug;
  }

  headings.forEach(function (h) {
    if (!h.id) h.id = slugify(h.textContent);
  });

  // ── Build TOC ────────────────────────────────────────
  var toc = document.createElement('div');
  toc.className = 'article-toc';

  var tocTitle = document.createElement('p');
  tocTitle.className = 'article-toc__title';
  tocTitle.textContent = 'In This Article';
  toc.appendChild(tocTitle);

  var list = document.createElement('ul');
  list.className = 'article-toc__list';

  headings.forEach(function (h) {
    var li = document.createElement('li');
    li.className = 'article-toc__item article-toc__item--' + h.tagName.toLowerCase();

    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.className = 'article-toc__link';
    a.textContent = h.textContent.trim();

    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(h.id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', '#' + h.id);
      }
    });

    li.appendChild(a);
    list.appendChild(li);
  });

  toc.appendChild(list);

  // ── Insert before article body ───────────────────────
  body.parentNode.insertBefore(toc, body);
})();
